export enum RoleType {
  NONE = "none",
  ADMIN = "administrator",
  MANAGER = "manager",
  STORAGE = "warehouse",
}
